<!--
구매금액 합계
------------------------------------
-->
<template>

    <div class="uk-flex uk-flex-bottom">
        <div class="title">
            선택합계(구입단가) :
        </div>


        <div v-for="(price, index) in checkedBuyPriceSum" :key="index">
            <span class="currency">{{ price.currency }}</span>
            <span class="price">{{ price.price }}</span>
        </div>
    </div>

</template>

<script>

    export default {
        mixins: [
        ],
        props: {
            /**
             * 일괄기능 공유data (상세정의는 컨트롤러 참고)
             */
            batch: Object,
        },
        data: function () {
            
            return {
            };
        },
        computed: {
            /**
             * 선택된 아이템 배열 (이거 batch.checked_items 에 이미 있는정보지만, 변경사항 감지가 안되서 여기서 다시 정의함.)
             * @return array
             */
            checkedItems() {
                // 선택 된 아이템만 필터
                return _.filter(this.batch.items, ['checked', true]);
            },

            /**
             * 선택한 항목의 구매금액 합계
             * @returns {array}
             */
            checkedBuyPriceSum() {
                let prices = [];

                // 화폐단위로 그룹바이
                let by_currency = _.groupBy(this.checkedItems, 'buy_unit_price_currency');

                // 각 화폐단위별로 sum
                prices = _.map(by_currency, (items, currency) => {
                    let total = _.sumBy(items, (item) => {
                        let val = item.buy_unit_price * item.amount;
                        return _.round(val, 2);
                    });

                    // JPY는 소수점 2자리 표현안함
                    let display_2digits = true;
                    if (currency === 'JPY') {
                        display_2digits = false;
                    }

                    // TASK-149: 콤마 표시 — 전역 메서드 $formatNumber (utils/format-number.js 단일 출처). JPY 0 / 그 외 2 (기존 toFixed 자릿수 유지)
                    return {
                        currency: currency,
                        price: this.$formatNumber(total, display_2digits ? 2 : 0),
                    };
                });
                return prices;

            }

        },
        methods: {

        },
    }
</script>

<style lang="scss" scoped>
.title {
    color: #000;

}
.currency {
    margin-left: 1rem;
    color: #666;
}
.price {
    color: #000;
    font-size: 1.5rem;
}
</style>